import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const gForceCalculatorTool: Tool = {
  id: "g-force-calculator",
  name: () => m.gf_tool_name(),
  description: () => m.gf_tool_description(),
  icon: "🌀",
  basePath: "/g-force-calculator",
  status: "stable",
  tags: [
    "science",
    "lab",
    "centrifuge",
    "rcf",
    "g-force",
    "g-force-calculator",
  ],
};
